<template>
  <form
    action="#"
    method="get"
    class="grid-controls"
    >
    <div class="grid-controls__count">
      <span class="grid-count__text">
        {{ filterMessage }}
        <a
          v-if="showResetLink"
          aria-controls="ajax-results-container"
          aria-label="Reset form to default values"
          href="javascript:void(0)"
          @click="reset()"
        >
          {{ filterTotalMessage }}
        </a>
        online
      </span>
    </div>

    <div class="grid-controls__right">
      <div class="grid-controls__item">
        <div class="form__checkbox-container">
          <label
            class="form__checkbox-label"
            for="in_print"
            >
            <span class="form__checkbox-label__text">In print</span>
          </label>
          <div class="form__checkbox">
            <input
              id="in_print"
              class="form__checkbox__input"
              name="in_print"
              type="checkbox"
              :checked="inPrint"
              @click="$emit('updateInPrint', !inPrint)"
            >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              class="form__checkbox__svg"
              >
              <path
                d="M2.5 7.5l4 4 7-7"
                fill="none"
                vector-effect="non-scaling-stroke"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="grid-controls__item">
        <div class="form__dropdown">
          <select
            id="category"
            v-model="selected"
            class="form__dropdown__select"
            name="category"
            @change="$emit('updateCategory', $event.target.value)"
          >
            <option
              v-for="cat in categories"
              :key="cat.Name.String"
              :selected="cat.Name.String"
              >
              {{ cat.Name.String }}
            </option>
          </select>
          <label
            class="form__dropdown-label"
            for="category"
            v-html="categoryDropDown"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { embedSVG, addSvgToEnd } from "Helpers/embedSVG";
import i18n from "../../utils/i18n.js";

export default {
  props: {
    total: { type: Number, required: true },
    filteredTotal: { type: Number, required: true },
    inPrint: { type: Boolean, required: true },
    category: { type: String, required: true },
    categories: { type: Array, required: true },
  },

  data: function () {
    return {
      selected: this.category.replaceAll("_", " "),
      i18n: new i18n(),
    };
  },

  computed: {
    categoryDropDown() {
      return addSvgToEnd(
        this.selected,
        "form__dropdown-label__text",
        "16_double_arrow.svg",
        "form__dropdown-label__svg test"
      );
    },

    inPrintCheckbox() {
      return embedSVG("icon__check--16--stroke.svg", "form__checkbox__svg");
    },

    filterMessage() {
      if (this.filteredTotal == 0) {
        return this.i18n.t("publications__no-results");
      } else if (this.filteredTotal == this.total) {
        return this.filterTotalMessage;
      }

      return this.i18n.t("publications__results", {
        Count: this.filteredTotal,
      });
    },

    showResetLink() {
      return this.total != this.filteredTotal;
    },

    filterTotalMessage() {
      return this.i18n.t("publications__total", { Count: this.total });
    },
  },

  methods: {
    reset() {
      this.selected = this.categories[0].Name.String;
      this.$emit('reset');
    }
  }
};
</script>
